import React from 'react';
import { Spinner } from 'reactstrap';

const Loader = ({small, text, padding}) => (
    <div className={`d-flex align-items-center  ${padding ? 'p-3' : 'p-1'}`}>
        {small ?
            <Spinner style={{height: '1.3rem', width: '1.3rem', borderWidth: '2px', position: 'relative', top: '-2px'}} />
            :
            <Spinner style={{ width: '50px', height: '50px', borderWidth: '7px' }} />
        }
        {text && <div className="ml-3">{text}...</div>}
    </div>
);
export default Loader;
